import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49c34878"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = { class: "py-4 sm:py-10 lg:py-4 xl:py-10" }
const _hoisted_4 = { class: "row-span-2 p-6 max-w-sm h-fit bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700" }
const _hoisted_5 = { class: "text-center font-bold mb-3" }
const _hoisted_6 = { class: "video-container" }
const _hoisted_7 = { class: "aspectRatioContainer" }
const _hoisted_8 = { class: "font-bold mt-3" }
const _hoisted_9 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_10 = { class: "py-6 font-bold" }

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import { useCameraTest } from '@/composables/zoom-diagnostic/useCameraTest'
import { useDevices } from '@/composables/video-diagnostic/useDevices'
import { Stage } from '@/types/enums/zoom-diagnostic.enum'
import { watch } from 'vue'

interface CameraTestEmits {
  (e: 'nextStage', value: number): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraTest',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const {
  stopVideoTrackZoom,
  videoInputTest,
  setVideoInputTestResult,
  videoElementRef,
  selectedVideo,
} = useCameraTest()
const { videoInputDevices } = useDevices()

watch(
  () => props.stage,
  async (stage, prevStage) => {
    if (prevStage === Stage.CAMERA_TEST) {
      stopVideoTrackZoom()
    }
    if (stage === Stage.CAMERA_TEST) {
      videoInputTest()
    }
    if (stage === Stage.RESULTS) {
      videoInputTest()
    }
  },
)

watch(videoInputDevices, () => {
  initSelectedVideo()
})

const nextStage = (testResult: boolean) => {
  setVideoInputTestResult(testResult)
  emit('nextStage', Stage.AUDIO_TEST)
}

const initSelectedVideo = () => {
  if (!selectedVideo.value) {
    selectedVideo.value = videoInputDevices.value[0].value
  }
}

return (_ctx: any,_cache: any) => {
  const _component_SelectOption = _resolveComponent("SelectOption")!

  return (_openBlock(), _createBlock(DiagnosticSection, {
    id: _unref(Stage).CAMERA_TEST,
    class: _normalizeClass(
      [_unref(Stage).GET_STARTED, _unref(Stage).CHECK_PERMISSIONS, _unref(Stage).PERMISSION_ERROR].includes(__props.stage)
        ? 'opacity-0'
        : __props.stage === _unref(Stage).CAMERA_TEST || __props.stage === _unref(Stage).RESULTS
        ? 'block'
        : 'hidden md:block opacity-30 pointer-events-none'
    )
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('zoom-diagnostic.check-video-camera')), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('zoom-diagnostic.check-video-camera-detail')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('zoom-diagnostic.video-preview')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("video", {
              ref_key: "videoElementRef",
              ref: videoElementRef,
              playsInline: ""
            }, null, 512)
          ])
        ]),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('zoom-diagnostic.camera')), 1),
        _createVNode(_component_SelectOption, {
          modelValue: _unref(selectedVideo),
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedVideo) ? (selectedVideo).value = $event : null)),
            _unref(videoInputTest)
          ],
          options: _unref(videoInputDevices),
          class: "w-full"
        }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('zoom-diagnostic.video-look-ok')), 1),
        _createElementVNode("div", {
          class: _normalizeClass([{ 'opacity-30 pointer-events-none': __props.stage === _unref(Stage).RESULTS }, "flex"])
        }, [
          _createElementVNode("button", {
            class: "bg-primary-color text-white border-2 rounded-md border-white py-2 px-4",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (nextStage(true)))
          }, _toDisplayString(_ctx.$t('zoom-diagnostic.test-pass')), 1),
          _createElementVNode("button", {
            class: "bg-primary-color skip-button rounded-md py-2 px-4 ml-4",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (nextStage(false)))
          }, _toDisplayString(_ctx.$t('zoom-diagnostic.test-fail')), 1)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})